import {
  useQuery,
} from '@tanstack/react-query'
import api  from '../../services/api';


export const useViewTagsQuery = () => {

  return useQuery({
    queryKey: ['viewTags'],
    queryFn: async () => {
        console.log('View tags request body:');
      const res = await api.get("/tag/list");
      return res.data;
    }
  });
};